import axios from "axios";
import { createApiClient } from "./api-client-generated";

export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL ?? "/";

export const axiosInstance = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
});

// Add CSRF token handling
axiosInstance.interceptors.request.use((config) => {
  const csrfToken = config.headers?.["x-csrf-token"];
  if (config.method !== "get" && !csrfToken) {
    const token = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");
    if (token) {
      config.headers = config.headers || {};
      config.headers["x-csrf-token"] = token;
    }
  }
  return config;
});

axiosInstance.interceptors.response.use((response) => {
  const csrfToken = response.headers?.["x-csrf-token"];
  if (csrfToken) {
    // Store the token in a meta tag for future requests
    let metaTag = document.querySelector('meta[name="csrf-token"]');
    if (!metaTag) {
      metaTag = document.createElement("meta");
      metaTag.setAttribute("name", "csrf-token");
      document.head.appendChild(metaTag);
    }
    metaTag.setAttribute("content", csrfToken);
  }
  return response;
});

const ApiClient = createApiClient(BACKEND_URL, {
  axiosInstance,
  validate: "none",
});

export default ApiClient;
